import { render, staticRenderFns } from "./Symptom.vue?vue&type=template&id=525d87a0&"
import script from "./Symptom.vue?vue&type=script&lang=js&"
export * from "./Symptom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports